export var InstagramChannelType;
(function (InstagramChannelType) {
    InstagramChannelType[InstagramChannelType["DIRECT_MESSAGE"] = 0] = "DIRECT_MESSAGE";
    InstagramChannelType[InstagramChannelType["STORY_MENTION"] = 10] = "STORY_MENTION";
    InstagramChannelType[InstagramChannelType["STORY_REPLY"] = 20] = "STORY_REPLY";
})(InstagramChannelType || (InstagramChannelType = {}));
//# sourceMappingURL=instagram-channel-type.enum.js.map